import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

let supabaseAccessToken ='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmY2Z4eHl3ZGNydnN0YmRienh5Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcwMDA2MDcwMywiZXhwIjoyMDE1NjM2NzAzfQ.aUwa6l7WB-z2IHSuJrwmgpc82qiPqH6PAPj8O1bpbKc';

class ReviewService {
    getDocReviewCount = async (Id) => {
        try {
            const response = await axiosConfig.get(`https://vfcfxxywdcrvstbdbzxy.supabase.co/functions/v1/reviews/get_doc_review_count/${Id}`, { headers: { Authorization: `Bearer ${supabaseAccessToken}` } });
            return response;
        } catch (error) {
            // const errorMessage = error?.message || "No Reviews"; // Fallback message
            // // Show the error message as a toast notification
            // toast.error(errorMessage);
            // // Re-throw the error for further handling if needed
            // throw new Error(error);
        }
    };
    getReview = async (Id) => {
        try {
            const response = await axiosConfig.get(`https://vfcfxxywdcrvstbdbzxy.supabase.co/functions/v1/reviews/doc/${Id}`, { headers: { Authorization: `Bearer ${supabaseAccessToken}` } });
            return response;
        } catch (error) {
            // const errorMessage = error?.message || "No Reviews"; // Fallback message
            // // Show the error message as a toast notification
            // toast.error(errorMessage);
            // // Re-throw the error for further handling if needed
            // throw new Error(error);
        }
    };
    
}

const instance = new ReviewService();

export default instance;
